import { useMemo } from "react";
import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { useAuth } from "@clerk/clerk-react";
import { resolveAuthHeaders } from "./authHeaders";

export const useApolloClient = () => {
  const { getToken, isSignedIn } = useAuth();

  const client = useMemo(() => {
    const httpLink = createHttpLink({
      uri: import.meta.env.VITE_API_URL || "/graphql",
    });

    // Attach the Clerk Bearer token for signed-in callers. On a token hiccup this retries
    // once and then throws, so the operation fails visibly instead of being sent
    // unauthenticated (a silent 401). Guests send no auth header at all.
    const authLink = setContext((_, { headers }) =>
      resolveAuthHeaders((headers as Record<string, string>) || {}, { isSignedIn, getToken })
    );

    return new ApolloClient({
      link: authLink.concat(httpLink),
      cache: new InMemoryCache(),
    });
  }, [getToken, isSignedIn]);

  return client;
};
